module.exports = __webpack_public_path__ + "static/media/b-img-2.b34a6763.png";